import adminAxiosInstance from "./api/adminAxiosInstance";

const getDashboardMetrics = async () => {
  const response = await adminAxiosInstance.get("contract/dashboard-metrics");
  return response.data;
};

const searchContracts = async (
  limit,
  offset,
  order,
  status,
  clientSearch,
  idPurchase,
  promotionName,
  isRepurchase
) => {
  const params = new URLSearchParams({ limit, offset, order });

  if (status) params.append("status", status);
  if (idPurchase) params.append("idPurchase", idPurchase);
  if (promotionName) params.append("promotionName", promotionName);
  if (isRepurchase !== undefined && isRepurchase !== "")
    params.append("isRepurchase", isRepurchase);

  if (clientSearch) {
    const isNumeric = /^\d+$/.test(clientSearch.replace(/[^\d]/g, ""));
    params.append(isNumeric ? "cpfCnpj" : "name", clientSearch);
  }

  const response = await adminAxiosInstance.get(
    `contractreturn/search?${params.toString()}`
  );
  return response.data;
};

const updateContractDetails = async (contractId, payload) => {
  const response = await adminAxiosInstance.put(
    `contract/${contractId}/details`,
    payload
  );
  return response.data;
};

const getPendingContracts = async (
  page = 1,
  limit = 10,
  order = "date_desc",
  clientSearch = "",
  isRepurchase
) => {
  const offset = (page - 1) * limit;
  const params = new URLSearchParams({
    limit,
    offset,
    order,
    status: 4,
  });

  if (clientSearch) {
    const isNumeric = /^\d+$/.test(clientSearch.replace(/[^\d]/g, ""));
    params.append(isNumeric ? "cpfCnpj" : "name", clientSearch);
  }

  if (isRepurchase !== undefined && isRepurchase !== "")
    params.append("isRepurchase", isRepurchase);

  const response = await adminAxiosInstance.get(
    `contractreturn/search?${params.toString()}`
  );
  return response.data; // Deve retornar um objeto { results: [], totalContracts: X }
};

const prolongContract = async (contractId, payload) => {
  const response = await adminAxiosInstance.patch(
    `contract/${contractId}/prolong`,
    payload
  );
  return response.data;
};

const buybackContract = async (contractId) => {
  const response = await adminAxiosInstance.post(
    `contractreturn/${contractId}/buybackdaddy`,
    {}
  );
  return response.data;
};

const cancelContract = async (contractId, clientId) => {
  const config = { headers: { "X-Client-ID": clientId } };
  const response = await adminAxiosInstance.post(
    `contractreturn/${contractId}/cancel`,
    {},
    config
  );
  return response.data;
};

const addPlus = async (contractId, payload) => {
  const response = await adminAxiosInstance.post(
    `contract/${contractId}/plus`,
    payload
  );
  return response.data;
};

const antecipateProfit = async (contractId, payload) => {
  const response = await adminAxiosInstance.post(
    `contract/${contractId}/antecipate`,
    payload
  );
  return response.data;
};

const updateContractStatus = async (contractId, newStatus) => {
  const response = await adminAxiosInstance.put(`contract/${contractId}`, {
    newStatus,
  });
  return response.data;
};

const approveRepurchase = async (contractId, approved) => {
  const response = await adminAxiosInstance.post(
    `contractreturn/${contractId}/approve-repurchase?approved=${approved}`
  );
  return response.data;
};

const createContractByAdmin = async (payload) => {
  const response = await adminAxiosInstance.post("contract/admin", payload);
  return response.data;
};

const getAvailabilityAnalysis = async (clientId) => {
  const config = {
    headers: {
      "X-Client-ID": clientId,
    },
  };

  const response = await adminAxiosInstance.get(
    `contract/availability-analysis/${clientId}`,
    config
  );
  return response.data;
};

const repurchaseWithBalanceAdmin = async (payload) => {
  const response = await adminAxiosInstance.post(
    "contractreturn/repurchase-with-balance-admin",
    payload
  );
  return response.data;
};

const repurchaseAndWithdraw = async (payload) => {
  const response = await adminAxiosInstance.post(
    "contractreturn/repurchase-and-withdraw",
    payload
  );
  return response.data;
};

const getClientAuditDetails = async (clientId) => {
  const response = await adminAxiosInstance.get(
    `contractreturn/${clientId}/audit-details`
  );
  return response.data;
};

const getNegativeProfitLeft = async () => {
  const response = await adminAxiosInstance.get(
    `contractreturn/negative-profit-left`
  );
  return response.data;
};

const removeReceipt = async (contractId) => {
  const response = await adminAxiosInstance.delete(
    `contract/${contractId}/receipt`
  );
  return response.data;
};

export const contractAdminService = {
  searchContracts,
  updateContractDetails,
  prolongContract,
  buybackContract,
  cancelContract,
  addPlus,
  antecipateProfit,
  updateContractStatus,
  approveRepurchase,
  createContractByAdmin,
  getPendingContracts,
  getAvailabilityAnalysis,
  repurchaseWithBalanceAdmin,
  repurchaseAndWithdraw,
  getClientAuditDetails,
  getNegativeProfitLeft,
  removeReceipt,
  getDashboardMetrics
};
